var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.64 3.52l-.8-.02h-5.49v.85l1.402.105c1.573-.01 1.723 1.155 1.723 1.463 0 .484-.56 1.61-1.223 3.272l-3.897 9.655L20.529 7.13c-.462-1.01-.372-1.3-.362-1.457a1.53 1.53 0 01.36-.77c.133-.158.47-.448.83-.448l1.45-.105V3.5h-8.62C9.77 3.5 6.5 7.115 6.5 11.535v3.2c0 4.42 3.292 8.063 7.712 8.063h18.79c4.63 0 7.82-3.39 7.875-8.063v-3.2c0-2.467-.985-4.598-2.56-6.043a7.58 7.58 0 00-4.678-1.972zM14.166 21.843c-3.908 0-6.737-3.178-6.737-7.085v-3.2c0-3.905 2.83-7.103 6.737-7.103h.5c.773.018 1.232.255 1.565.522.34.273.672.833.992 1.66.24.638.418 1.098.53 1.36l5.713 13.843h-9.3v.003zm25.737-7.085c0 3.782-2.605 7.082-6.862 7.082h-7.8l4.887-12.223 1.17-2.88c.288-.717.76-1.502 1.148-1.867.377-.355.828-.413 1.355-.413h-.027c2.837 0 6.13 2.863 6.13 7.103v3.2-.002z",
    fill: "#AB2328"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f4384cfc8c1efe196578aaca809c234f.svg";
export { ForwardRef as ReactComponent };